import React from 'react';
import { observer } from 'mobx-react-lite';

const Tank = observer(({ tankVolume, tanksCount }) => {
  if (!(tankVolume || tanksCount)) return null;

  const renderTank = () => {
    return [tankVolume && `${tankVolume} л`, tanksCount && `${tanksCount} шт`]
      .filter((el) => el)
      .join(', ');
  };

  return (
    <tr>
      <td className="pale">Бак</td>
      <td>{renderTank()}</td>
    </tr>
  );
});

export default Tank;
